import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import PricingHero from "./components/PricingHero";
import PricingCards from "./components/PricingCards";
import FeatureComparisonTable from "./components/FeatureComparisonTable";
import HowPricingWorks from "./components/HowPricingWorks";
import ProductCoverage from "./components/ProductCoverage";
import ImplementationJourney from "./components/ImplementationJourney";
import AddOnServices from "./components/AddOnServices";
import SocialProof from "./components/SocialProof";
import PricingFAQ from "./components/PricingFAQ";
import FinalCTA from "./components/FinalCTA";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function PricingPage() {
  usePageMeta(
    "Flexible Pricing for Every Stage of Growth | StackMap Systems",
    "Tailored pricing for StackMap\u2019s operational SaaS products. Choose Start, Grow, Transform, or Enterprise plans based on your company size, modules, implementation scope, integrations, and support requirements."
  );

  return (
    <div className="min-h-screen bg-graphite-900">
      <Navbar />
      <main>
        <PricingHero />
        <PricingCards />
        <FeatureComparisonTable />
        <HowPricingWorks />
        <ProductCoverage />
        <ImplementationJourney />
        <AddOnServices />
        <SocialProof />
        <PricingFAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}